export default class Helpers {
  static formatTextForAssetNames(text) {
    return text.toLowerCase().replace(/\s/g, '-')
  }

  static findTeamImageModule(teamName, brand = 'vc-sportshub-za-en') {
    const formattedName = this.formatTextForAssetNames(teamName)

    try {
      return require(`@/brand/${brand}/assets/logos/${formattedName}.png`)
    } catch (error) {
      try {
        return require(`@/brand/${brand}/assets/logos/${formattedName}.webp`)
      } catch (error) {
        try {
          return require(`@/assets/logos/default-team.png`)
        } catch (error) {
          return null
        }
      }
    }
  }

  static findSportImageModule(sportName, brand = 'vc-sportshub-za-en') {
    const formattedName = this.formatTextForAssetNames(sportName)

    try {
      return require(`@/brand/${brand}/assets/icons/${formattedName}.png`)
    } catch (error) {
      try {
        return require(`@/brand/${brand}/assets/icons/${formattedName}.webp`)
      } catch (error) {
        return null
      }
    }
  }

  static findNewsImageModule(imageName, brand = 'vc-sportshub-za-en') {
    if (!imageName) return null

    const formattedName = this.formatTextForAssetNames(imageName)

    try {
      return require(`@/brand/${brand}/assets/news/${formattedName}.jpg`)
    } catch (error) {
      try {
        return require(`@/brand/${brand}/assets/news/${formattedName}.png`)
      } catch (error) {
        try {
          return require(`@/brand/${brand}/assets/news/${formattedName}.webp`)
        } catch (error) {
          return null
        }
      }
    }
  }

  static getAssetUrl(path, brand = 'vc-sportshub-za-en') {
    try {
      return require(`@/brand/${brand}/assets/${path}`)
    } catch (error) {
      try {
        return require(`@/assets/${path}`)
      } catch (error) {
        return null
      }
    }
  }

  static formatDate(dateString) {
    const date = new Date(dateString)
    const now = new Date()
    const diff = now - date

    const minutes = Math.floor(diff / 60000)
    const hours = Math.floor(diff / 3600000)
    const days = Math.floor(diff / 86400000)

    if (minutes < 60) {
      return `${minutes}m ago`
    } else if (hours < 24) {
      return `${hours}h ago`
    } else if (days < 7) {
      return `${days}d ago`
    } else {
      return date.toLocaleDateString('en-ZA', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      })
    }
  }

  static truncateText(text, maxLength = 100) {
    if (!text || text.length <= maxLength) return text
    return text.substring(0, maxLength) + '...'
  }

  static formatMsisdn(phone) {
    let cleaned = phone.replace(/\s/g, '').replace(/[^0-9]/g, '')
    if (cleaned.startsWith('0')) cleaned = '27' + cleaned.substring(1)
    if (!cleaned.startsWith('27')) cleaned = '27' + cleaned
    return cleaned
  }

  static formatCurrency(amount, currency = 'R') {
    const formatted = parseFloat(amount).toFixed(2)
    return `${currency}${formatted}`
  }
}
